<template>
  <div class="Module">
    <perfect-scrollbar class="scroll">
      <div
        class="item card"
        v-for="item in $store.state.wsModule.moduleLists"
        :key="item"
        :title="item"
        @click="onClick(item)"
        :class="select.includes(item)?'active':''"
      >
        <div class="ellipsis">{{ item }}</div>
      </div>
    </perfect-scrollbar>
    <!-- <div class="scroll"></div> -->
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, watch, computed } from 'vue'
import { store } from '@/store/index'

export default defineComponent({
  name: 'Module',
  setup() {
    const select = ref<any>([])
    watch(
      computed(()=>store.state.wsModule.currentModule),
      (e)=>{
        
        select.value = e
      }
    )
    let timer:any = null
    const onClick = (key: number) => {
      if(select.value.includes(key)){
        select.value.splice(select.value.indexOf(key),1)
      }else{
        select.value.push(key)
      }

      if(timer) clearTimeout(timer);
      timer = setTimeout(() => {
        const map = new Map();
        const {moduleLists, currentModule} = store.state.wsModule
        moduleLists.forEach(key => {
          map[key] = 'off'
        });
        for(let key of currentModule){
          map[key] = 'on'
        }
        store.dispatch('wsModule/WS_SendModules', map)
        
      }, 2000);
      // 
        // store.dispatch('wsModule/WS_SendModules',)

    }

    return {
      select,
      onClick
    }
  }
})
</script>
<style lang="less" scoped>
.Module {
  padding: 10px 0 10px 10px;
  margin-right: 10px;
  flex: 1;
}
.scroll {
  height: 100%;
}
.item {
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 10px;
  width: 47%;
  font-size: 12px;
  text-align: center;
  float: left;
}
:deep(.ps__rail-x){
  display: none;
}
</style>
